/* eslint no-console: 0*/

import React, { Profiler } from 'react';

const Profile = props => {
  const { children, ...rest } = props;

  // Only allow profiling for non prod builds
  if (process.env.NODE_ENV === 'production') {
    return children;
  }

  const profileHandler = (id, phase, actualDuration) => {
    if (actualDuration > 100) {
      console.warn(`[Profiler] It took ${id} ${actualDuration} to ${phase}`);
    }
  };

  return <Profiler {...rest} onRender={profileHandler}>{children}</Profiler>;
};

export default Profile;
